<template>
    <div class="fadein">
        <Goback></Goback>
        <div class="h30"></div>
        <div class="center1200 bg-white padding20 shadow">
            <div class="h20"></div>
            <div class="center-title"><img src="/static/img/title-left.png" alt="" class="title-pic"> 用户反馈 <img src="/static/img/title-right.png" alt="" class="title-pic"></div>
            <div class="h20"></div>
            <div style="width:1100px;margin:0 auto;line-height: 50px;font-size:18px;">
                您可以在这里报BUG、提出用户体验改善建议......<br>
                欢迎您随时反馈，我们虚心整改。
                <div class="h10"></div>
            <span v-if="token!=null">
                <el-input
                type="textarea"
                placeholder="请输入反馈内容"
                v-model="content"  
                maxlength="300"
                :autosize="{ minRows: 8 }"
                show-word-limit
                >
                </el-input>
                <div class="h20"></div>
                <div style="text-align: center;">
                    <el-button type="info" style="width:120px;" @click="sub">提交反馈</el-button>
                </div>
            </span>
            <span v-else>
                <div style="text-align: center;">
                    <router-link to="/login">
                        <el-button type="warning" style="width:120px;">登录后反馈</el-button>
                    </router-link>
                </div>
            </span>
            </div>
            <div class="h20"></div>
            
        </div>
        <div class="h30"></div>
    </div>
</template>
<script>
    import Goback from '@/components/components/goback';
    export default{
        components:{
            Goback,

        },
        data(){
            return {
                content:'',
                token:null,
            }
        },
        watch:{
            $route(newVal,oldVal){
                if(newVal.name == 'feedback'){
                    this.$parent.activeIndex = '0'

                }
            }

        },
        mounted(){
            this.$parent.activeIndex = '0'
            this.getUserinfo();
        },
        methods:{
            
            sub(){
                if(this.content==''){
                    this.$message({
                        showClose:true,
                        message:"提交的反馈不能为空",
                        type:"info"
                    })
                    return false;
                }
                $.ajax({
                    url:"//"+ this.$API_URL +"/api/v1/users/feedback",
                    type:"post",
                    data:{user_id:this.token,feedback:this.content},
                    success:(ret)=>{
                        if(ret.code == 201){
                            this.$message({
                                showClose:true,
                                message:"反馈成功，我们已经收到了您的建议。",
                                type:"warning"
                            })
                            this.content = ''
                        }
                    }
                })

            },

            //获取当前用户的信息
            getUserinfo() {
                this.token = localStorage.getItem('token')
                if(this.token==null){
                    return false;
                }
            },
        }
    }
</script>
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/components/index/feedback.vue